
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBlockgroupOnScenario",
      resolverType: "query",
      routePath: "/getBlockgroupOnScenario",
      httpMethod: "POST",
    });
  